
import { ref, Ref, defineComponent, onMounted, nextTick } from "vue";
import Console from "./components/Console.vue";

import {darkMode} from './globals';

declare const FATE: any;
export default defineComponent({
  name: "App",
  components: {
    Console,
  },
  setup() {
    const fateLoaded = ref(false);
    const gameLoaded = ref(false);
    const gameStarted = ref(false);
    const gameState = ref("");
    const showMenu = ref(false);
    const showBuiltInMenu = ref(false);
    const showInitMenu = ref(true);
    const fileInput = ref();
    const fileType = ref(".js");
    const init = ref(null);

    const builtInGames = ref([]);
    const selectedBuiltIn = ref();

    fetch(`./built-in-games.json?r=`+Date.now())
      .then(response => response.json())
      .then(games => {
        nextTick(() => {
          builtInGames.value = games;
        });
      });

    function fetchFateGame(url: string) {
      fetch(url+'?r='+Date.now(), { headers: { "Content-Type": "text/plain" } })
        .then((response) => response.text())
        .then((content) => {
          loadGame(content);
        });
    }

    onMounted(() => {
      const gameUrl = new URLSearchParams(window.location.search).get("game");
      if (gameUrl) {
        if (!window['FATE']) {
          const awaitFate = () => {
            if (!window['FATE']) {
              console.log('waiting for FATE...');
              setTimeout(awaitFate, 100);
            } else {
              fetchFateGame(decodeURIComponent(gameUrl));
            }
          }
          setTimeout(awaitFate, 100);
        }
      }
    });

    function loadGame(content: string) {
      gameLoaded.value = false;
      const game = document.createElement("script");
      game.id = "fate-game";

      const waitForLoad = () => {
        console.log("waiting for game to load...");
        if (FATE.game) {
          gameLoaded.value = true;
          init.value = null;
        } else {
          setTimeout(waitForLoad, 100);
        }
      };
      setTimeout(waitForLoad, 100);

      document.head.querySelector("#fate-game")?.remove();
      document.head.appendChild(game);

      game.text = content;
      showInitMenu.value = false;
    }

    function loadFile($event: Event) {
      const file = ($event.target as any).files[0];
      const reader: FileReader = new FileReader();

      reader.onload = (ev: ProgressEvent<FileReader>): any => {
        switch (fileType.value) {
          case ".js":
            gameState.value = "";
            loadGame(ev?.target?.result as string);
            break;
          case ".fs":
            nextTick(() => {
              gameState.value = "";
              nextTick(() => {
                gameState.value = ev?.target?.result as string;
              });
            });
            break;
        }
      };
      fileInput.value.value = null;
      reader.readAsText(file);
    }

    function loadBuiltIn() {
      if (!selectedBuiltIn.value) return;

      const filename = selectedBuiltIn.value.filename;
      selectedBuiltIn.value = null;
      showBuiltInMenu.value = false;
      showMenu.value = false;
      fetchFateGame(`./games/${filename}`);
    }

    function loadFromFile() {
      fileType.value = ".js";
      showMenu.value = false;
      nextTick(() => {
        fileInput.value.click();
      });
    }

    function startGame() {
      showMenu.value = false;
      gameState.value = "";
      init.value = FATE.startGame();
    }

    function saveState() {
      window.alert('Saving game... check your downloads folder for confirmation.');
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(FATE.saveState())
      );
      
      element.setAttribute("download", `${FATE.game.name.replace(/ /g, '_').replace(/[^a-zA-Z_]/g, '')}.fs`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
      showMenu.value = false;
    }

    function loadState() {
      fileType.value = ".fs";
      showMenu.value = false;
      nextTick(() => {
        fileInput.value.click();
      });
    }

    function toggleMenu() {
      showMenu.value = !showMenu.value;
    }

    const fate = document.createElement("script");
    fate.src = `./fate.js?r=`+Date.now();

    fate.onload = () => {
      fateLoaded.value = true;
    };

    document.head.appendChild(fate);

    return {
      fateLoaded,
      gameLoaded,
      gameStarted,
      loadFile,
      loadBuiltIn,
      loadFromFile,
      startGame,
      init,
      gameState,
      showMenu,
      showBuiltInMenu,
      showInitMenu,
      toggleMenu,
      fileInput,
      fileType,

      saveState,
      loadState,

      builtInGames,
      selectedBuiltIn,

      darkMode,

      goToInstructions(instructions) {
        window.open(`./instructions/${instructions}.html`, '_blank');
      }
    };
  },
});
